import {EnumDetailsInterface} from "~/interfaces/enum";

export enum ProcessFlowOperator {
  Append = 1,
  Prepend = 2,
  SetTo = 3,
  Clear = 4,
  Select = 5,
  Unselect = 6,
  Initialize = 7,
  Remove = 8,
  CombinePdf = 9,
  ResizeImage = 10,
}

// order that we always want operators to appear in. update with new operators as needed.
export const MASTER_OPS_ORDER: Array<ProcessFlowOperator> = [
  ProcessFlowOperator.Initialize,
  ProcessFlowOperator.Append,
  ProcessFlowOperator.Prepend,
  ProcessFlowOperator.SetTo,
  ProcessFlowOperator.Select,
  ProcessFlowOperator.Unselect,
  ProcessFlowOperator.CombinePdf,
  ProcessFlowOperator.ResizeImage,
  ProcessFlowOperator.Remove,
  ProcessFlowOperator.Clear,
];

export const ProcessFlowOperatorDetails: EnumDetailsInterface = {
  [ProcessFlowOperator.Append]: {
    displayName: "Append"
  },
  [ProcessFlowOperator.SetTo]: {
    displayName: "Set To"
  },
  [ProcessFlowOperator.Clear]: {
    displayName: "Clear"
  },
  [ProcessFlowOperator.Prepend]: {
    displayName: "Prepend"
  },
  [ProcessFlowOperator.Select]: {
    displayName: "Select"
  },
  [ProcessFlowOperator.Unselect]: {
    displayName: "Unselect"
  },
  [ProcessFlowOperator.Initialize]: {
    displayName: "Initialize"
  },
  [ProcessFlowOperator.Remove]: {
    displayName: "Remove"
  },
  [ProcessFlowOperator.CombinePdf]: {
    displayName: "Combine PDFs"
  },
  [ProcessFlowOperator.ResizeImage]: {
    displayName: "Shrink Image Size"
  },
} as const

export const SetToClearOperators = [
  ProcessFlowOperator.SetTo,
  ProcessFlowOperator.Clear
] as const

export const AppendPrependOperators = [
  ProcessFlowOperator.Append,
  ProcessFlowOperator.Prepend
] as const

export const SelectUnselectOperators = [
  ProcessFlowOperator.Select,
  ProcessFlowOperator.Unselect
] as const